// Angular
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
// Local services
import { ClienteService } from '../../services/cliente.service';
// 3rd libraries
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Common functions
import { CommonFunctions } from '../../utils/common-functions';
import * as codigoInstituciones from '../../localDataJson/codigoinstituciones.json';
import {MatDialog} from '@angular/material/dialog';
import { ModalCcrComponent } from '../../components/modal-ccr/modal-ccr.component';
import swal from "sweetalert2";
import { NgxPermissionsService } from 'ngx-permissions';
import * as moment from "moment";
@Component({
  selector: 'app-gestiones-ofertacomercial',
  templateUrl: './gestiones-ofertacomercial.component.html',
  styleUrls: ['./gestiones-ofertacomercial.component.scss']
})
export class GestionesOfertacomercialComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Output() selectgestion = new EventEmitter<any>();
  @Input() participante: any
 // @Input() gestionSeleccionada: any
  @Input() clienteserviceParam: ClienteService
  precalificacionSeleccionada
  @Input() set gestionSeleccionada(value: any) {
    this.banderccrcodeudor = false
    this.precalificacionSeleccionada = value
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    setTimeout(() => {
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.validateCCRcodeudor()
      this.validateFechaVencimiento()
      this.setConsolidacionTotal()
    }, 1000);
  }
  instituciones: any = (codigoInstituciones as any).default;
  commonFunctions = CommonFunctions;
  liquidezfinal = 0
  totalconsolidacion=0
  creditosConsolidados = []
  banderccrcodeudor = false
  banderavencimiento=false//valida la fecha de expiración de la precalificación
  constructor(private ngxUiLoaderService: NgxUiLoaderService,
    private ngxPermissionService: NgxPermissionsService,public dialog: MatDialog) {

  }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
  validateCCRcodeudor() {
    let auxflag=this.precalificacionSeleccionada.ofertaComercialSeleccionada.politica.find(
      (i) => i.reglaDecision === "SIN DECISION" && i.reglaParticipante == "Codeudor" && i.reglaCod=='0011'
    )
    if (auxflag != null) {
      this.banderccrcodeudor=true
    }
  }
  validateFechaVencimiento() {
    let date1 = moment(new Date()).format('DD/MM/YYYY')
    let date2 = this.precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.fechaVencimientoOferta
    this.banderavencimiento=this.clienteserviceParam.dateIsBefore(date1,date2)
    console.log(this.banderavencimiento)
  }
  setConsolidacionTotal() {
    let totalconsolicacion = 0
    this.creditosConsolidados=[]
    if (this.precalificacionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionCreditoBT != null) {
      this.precalificacionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionCreditoBT.forEach(element => {
        if (element.consolida == "S") {
          element.tipo='Prestamo BT'
          this.creditosConsolidados.push(element)
          totalconsolicacion+=Number(element.saldo)
        }
      })
    }
    if (this.precalificacionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionSirc != null) {
      this.precalificacionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionSirc.forEach(element => {
        if (element.consolida == "S") {
          element.CodEntidad = this.instituciones.find(i => i.nomEntidad == element.nomEntidad).Codigo_Intitución
          element.tipo=element.descTipoActivo+' - ext'
          this.creditosConsolidados.push(element)
          totalconsolicacion+=Number(element.saldo)
        }
      });
    }
    if (this.precalificacionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionTarjetaBT != null) {
      this.precalificacionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionTarjetaBT.forEach(element => {
        if (element.consolida == "S") {
          element.tipo="TC BT"
          this.creditosConsolidados.push(element)
          totalconsolicacion+=Number(element.saldo)
        }
      })
    }
    console.log('creditos consolidados', this.creditosConsolidados)
    this.totalconsolidacion= totalconsolicacion
  }
  setLiquidezFinal() {
    return this.getLiquidezFinal(
      this.precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro,
      this.precalificacionSeleccionada.participante[this.participante].outLiquidezFinal.outSumaCuotaCreditosVigentesBT,
      this.precalificacionSeleccionada.participante[this.participante].outLiquidezFinal.outSumaCuotaTcVigentesBT,
    );
  }
  getLiquidezFinal(
    cuotaNuevoCreditoConSeguro,
    outSumaCuotaCreditosVigentesBT,
    outSumaCuotaTcVigentesBT,
  ) {
    this.liquidezfinal = 0;
    if (this.participante === 0) {
      if (this.precalificacionSeleccionada.participante[0].datosIndice.patrono.indicaIndice === 'S') {
        if (+this.precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg === 1) {
          return this.liquidezfinal = 250
            + Number(this.precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaM);
        } else {
          return this.liquidezfinal = 250
            + Number(cuotaNuevoCreditoConSeguro);
        }
      } else {
        return this.liquidezfinal = 250
          + Number(cuotaNuevoCreditoConSeguro)
          + Number(outSumaCuotaCreditosVigentesBT)
          + Number(outSumaCuotaTcVigentesBT);
      }
    } else {
      if (this.precalificacionSeleccionada.participante[1].datosIndice.patrono.indicaIndice === 'S') {
        return this.liquidezfinal = 250
          +Number(this.precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaMFiador) ;
      } else {
        return this.liquidezfinal = 250
          + Number(this.precalificacionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguroSinMaMFiador)
          + Number(outSumaCuotaCreditosVigentesBT)
          + Number(outSumaCuotaTcVigentesBT);
      }
    }
  }
  async integrarAbanca() {
    try {
      this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
      const datos = await this.clienteserviceParam.integracionBancaBT( this.precalificacionSeleccionada.noPrecalificacion, this.precalificacionSeleccionada.tipoProducto);
      if (datos.codigoError === '0') {
        this.precalificacionSeleccionada.estadoProceso = 'INTEGRADA_BT';
      } else {
        this.precalificacionSeleccionada.estadoProceso = 'OFERTA_SELECCIONADA';
        this.precalificacionSeleccionada.mensajeProceso = datos.mensajeTecnicoAPI;
      }
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
    } catch (e) {
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
    }
  }
  openModalCcr() {
    const dialogRef = this.dialog.open(ModalCcrComponent, {
      width: '800px',
      height:'auto',
      data: {datospreca: this.precalificacionSeleccionada.participante[0].sircRuta12.mensaje.contenido.activosCanceladosReserva }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        let politicaccr =[]
        politicaccr.push(this.precalificacionSeleccionada.ofertaComercialSeleccionada.politica.find(
          (i) => i.reglaDecision === "SIN DECISION"
        ))
       this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
       this.clienteserviceParam.changeColorPreca(result.productos, this.precalificacionSeleccionada.noPrecalificacion, politicaccr, this.precalificacionSeleccionada.ofertaComercialSeleccionada.estadoColorPrecalificacion, 'V', result.descripcion).then(result => {
         this.selectgestion.emit(this.precalificacionSeleccionada);
       }).catch(error => {
         this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
         this.showNotification('Alerta','Ha ocurrido un error.')
       }) 
      }
    })
  }
  showNotification(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }
  enviarComprobante(){
    let datapreca={
      noPrecalificacion:this.precalificacionSeleccionada.noPrecalificacion,
      usuarioAbf: this.precalificacionSeleccionada.informacionGeneral.usuarioAbf,
      fechaRegistro: this.clienteserviceParam.getDateFormat(this.precalificacionSeleccionada.fechaRegistro),
      nombreCompleto: this.precalificacionSeleccionada.participante[0].datosGenerales.nombreCompleto,
      tipoProducto: this.precalificacionSeleccionada.tipoProducto
    }
    let resultadoPreca=this.precalificacionSeleccionada.estadoColorPrecalificacion === 'ROJO'
    ? 'RECHAZADO' : this.precalificacionSeleccionada.estadoColorPrecalificacion === 'AMARILLO'
      ? 'EN REVISIÓN' : 'PREAPROBADO'
      this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    this.clienteserviceParam.sendEmailDetalleAB(resultadoPreca,datapreca,this.precalificacionSeleccionada.participante[0].datosGenerales.correoElectronico).then(result=>{
      this.clienteserviceParam.sendSmsAB(datapreca,this.precalificacionSeleccionada.participante[0].datosGenerales.telefonoMovil,resultadoPreca).then(snap=>{
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      }).catch(error=>{
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      })
          }).catch(error=>{
            this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
          })
  }
}
